export default "__VITE_ASSET__BquhbYRC__"